import { store } from "../stores/mainStore";
import { Integration } from "./Integration";
import { comm } from "../comm";
//import {Firebase} from "../thirdParty/firebase";

export class StandAlone extends Integration {

	PlatformId = "sa";

	constructor(){
		super();
		window.addEventListener("message", this.processMessage, false);
		// console.log('platform: GT', process.env);
		// this.postAnalyticsEvent("app_launch", "launch", {build: 0.01, userAgent: navigator.userAgent || navigator.vendor || window.opera}, "start");
	}

	initAnalytics(uid) {

	}

	postAnalyticsEvent(label, category="", value="none") {
		// return;
		if(process.env.NODE_ENV === 'development' && window.location.hash !== '#sendanalytics'){
			//return;
		}
		var data = {};
		data.event_label = label;
		if(category === 'tutorial') {
			if(store.user.xp !== 0)
				return;
			category = 'tutorial_ftue';
		}
		// eslint-disable-next-line
		data.event_category = (category && category != "") ? category : store.tutorialMode ? 'tutorial' : 'gameplay';
		data.value = (typeof value === 'number' || (typeof value === 'string' && value !== 'none')) ? value : Date.now().toString();
		//console.log('gtag: ', id, data);
		//window.gtag('event', id, data);

		// Firebase.logEvent(id, data);
		if(window.WrapperApp) {
			let msg = "firebase-event?label="+data.event_label+"&category="+data.event_category+"&value="+data.value;
			window.WrapperApp.postMessage(msg);
		} else {
			console.log("no wrapper yet posting message: "+label);
		}
	}

	setAnalyticsUserId(userId){
		// Firebase.setUserId(userId);

		window.WrapperApp.postMessage("firebase-username?userid="+userId);
}

	get tutorialWager(){
		return store.user.lastBetAmount;
	}

	get tutorialPayout(){
		return store.tutorialPayout;
		// var win = store.betAmounts[0] * 1.5;
		// if(win > 2000000000){
		// 	win = 2000000000;
		// }
		// return win;
	}

	login(){
		console.warn('not used for standalone');
	}

	processMessage = (msg) => {

	}

	processNotifications(){
		if(window.WrapperApp){
			// WrapperApp.postMessage('getting notifications to clear')
		}
		store.lastNotificationUpdate = Date.now();
		return comm.GetNotifications()
		.then((response) => {
			if(response === undefined){
				return;
			}
			// console.log(response);
			var nextRewards = [];
			var nextNudges = [];
			var nextNotifications = [];
			response.Payload.UserNotifications.forEach((n, i) => {
				// console.log('Notification', n);
				switch (n.Type) {
					case 'reward':
						// comm.ConfirmNotification(n.ConfirmationKey, i * 200);
						if(store.confirmedRewards.indexOf(n.ConfirmationKey) === -1){
							//add the reward as something we need to display to the user.
							if(n.Data.Achieve === "level" || n.Data.Achieve === 'tutorial'){
								comm.ConfirmNotification(n.ConfirmationKey);
							} else {
								if(Date.now() > store.suppressAchToastsUntil){
									store.suppressAchToastsUntil = Date.now() + (1000 * 30);
								} else {
									store.setSeenNotification(n.ConfirmationKey);
								}
								nextRewards.push(n);
							}
						} else {
							//We have already visually confirmed this award with the user
							//just confirm again with the server
							comm.ConfirmNotification(n.ConfirmationKey);
						}
						break;
					case 'nudge':
						nextNudges.push(n);
						break;
					case 'your_turn':
					case 'match_complete':
						comm.ConfirmNotification(n.ConfirmationKey, i * 200);
						break;
					default:
						nextNotifications.push(n);
						break;
				}
			});
			store.nudges.replace(nextNudges);
			store.rewards.replace(nextRewards);
			store.notifications.replace(nextNotifications);
		});
	}

	parseBetSizes(sizes){
		var bets = [];
		for(let i = 2; i >= 0; i--){
			bets.push(sizes[i]);
		}

		//create posCount positions
		var betsWithInterpolation = [];
		const posCount = 9;
		const perSide = (posCount - bets.length) / 2;
		betsWithInterpolation.push(bets[0]);
		const lowerIncrement = (bets[1] - bets[0]) / (Math.floor(perSide) + 1);
		for(let i = 1; i <= Math.floor(perSide); i++){
			betsWithInterpolation.push(lowerIncrement * i + bets[0])
		}
		betsWithInterpolation.push(bets[1])
		const upperIncrement = (bets[2] - bets[1]) / (Math.ceil(perSide) + 1);
		for(let i = 1; i <= Math.ceil(perSide); i++){
			betsWithInterpolation.push(upperIncrement * i + bets[1])
		}
		betsWithInterpolation.push(bets[2]);
		console.log(betsWithInterpolation);


		store.betAmounts.replace(betsWithInterpolation);
	}
}
